import React, { useState } from 'react';
import { Upload, CheckCircle, XCircle } from 'lucide-react';
import './AdminHome.css';

const AdminHome = () => {
  const [content, setContent] = useState('Welcome toWarangal');
  const [sliderImages, setSliderImages] = useState([]);
  const [featuredProfiles, setFeaturedProfiles] = useState([]);

  const handleContentChange = (e) => {
    setContent(e.target.value);
  };

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    setSliderImages([...sliderImages, ...files]);
  };

  const removeImage = (index) => {
    setSliderImages(sliderImages.filter((_, i) => i !== index));
  };

  const handleApproveChanges = () => {
    // Here you could integrate an API call to update the homepage content
    alert('Changes approved and applied to homepage!');
  };

  const handleAddFeaturedProfile = () => {
    const name = prompt('Enter the name of the new featured profile:');
    if (name) {
      // Simulate profile creation with a basic object. In a real app, you'd collect more data.
      const newProfile = { name };
      setFeaturedProfiles([...featuredProfiles, newProfile]);
    }
  };

  const handleEditPolicies = () => {
    // This function could open a modal for editing policies or redirect to another page.
    alert('Redirecting to policy editor...');
  };

  return (
    <div className="admin-home-J11">
      {/* Header */}
      <div className="admin-header-J11">
        <h1>Admin Home Management</h1>
        <button className="admin-btn-J11" onClick={handleApproveChanges}>
          <CheckCircle size={16} /> Approve Changes
        </button>
      </div>

      {/* Main Content */}
      <div className="admin-content-J11">
        {/* Homepage Content Editor */}
        <div className="admin-card-J11">
          <h2>Edit Homepage Content</h2>
          <textarea
            className="w-full p-2 border rounded"
            value={content}
            onChange={handleContentChange}
          />
        </div>

        {/* Slideshow Images Management */}
        <div className="admin-card-J11 admin-slideshow-J11">
          <h2>Manage Slideshow Images</h2>
          <input
            type="file"
            multiple
            onChange={handleImageUpload}
            className="hidden"
            id="imageUpload"
          />
          <label htmlFor="imageUpload" className="admin-btn-J11 cursor-pointer flex items-center gap-2">
            <Upload size={16} /> Upload Images
          </label>
          <div className="grid grid-cols-3 gap-4 mt-4">
            {sliderImages.map((image, index) => (
              <div key={index} className="relative border p-2 rounded">
                <img
                  src={URL.createObjectURL(image)}
                  alt="slider preview"
                  className="w-full h-24 object-cover"
                />
                <button
                  className="absolute top-1 right-1 bg-red-500 text-white p-1 rounded"
                  onClick={() => removeImage(index)}
                >
                  <XCircle size={16} />
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Featured Profiles Management */}
        <div className="admin-card-J11 admin-featured-profiles-J11">
          <h2>Manage Featured Profiles</h2>
          <button className="admin-btn-J11" onClick={handleAddFeaturedProfile}>
            Add Featured Profile
          </button>
          <div className="mt-4">
            {featuredProfiles.length === 0 && <p>No featured profiles added yet.</p>}
            {featuredProfiles.map((profile, index) => (
              <div key={index} className="flex justify-between items-center p-2 border-b">
                <span>{profile.name}</span>
                <button className="admin-btn-J11" onClick={() => {
                  // Remove profile functionality
                  setFeaturedProfiles(featuredProfiles.filter((_, i) => i !== index));
                }}>Remove</button>
              </div>
            ))}
          </div>
        </div>

        {/* Safety & Privacy Assurance */}
        <div className="admin-card-J11 admin-safety-J11">
          <h2>Safety & Privacy Assurance</h2>
          <p>
            Manage content moderation, user privacy settings, and security measures.
          </p>
          <button className="admin-btn-J11 mt-2" onClick={handleEditPolicies}>Edit Policies</button>
        </div>
      </div>
    </div>
  );
};

export default AdminHome;
